module.exports = __webpack_public_path__ + "img/logo-sass.9796e80b.svg";